import React, { useEffect, useMemo, useRef, useState } from "react";
import BreadPNG from "../img/bread.png";

const QUOTES = [
  { text: "Education is the most powerful weapon which you can use to change the world.", author: "Nelson Mandela" },
  { text: "The roots of education are bitter, but the fruit is sweet.", author: "Aristotle" },
  { text: "An investment in knowledge pays the best interest.", author: "Benjamin Franklin" },
  { text: "Education is not the learning of facts, but the training of the mind to think.", author: "Albert Einstein" },
  { text: "The beautiful thing about learning is that no one can take it away from you.", author: "B.B. King" },
  { text: "The more that you read, the more things you will know.", author: "Dr. Seuss" },
  { text: "Develop a passion for learning. If you do, you will never cease to grow.", author: "Anthony J. D'Angelo" },
  { text: "Education is the key to unlock the golden door of freedom.", author: "George Washington Carver" },
  { text: "The purpose of education is to replace an empty mind with an open one.", author: "Malcolm Forbes" },
  { text: "Learning is not attained by chance, it must be sought for with ardor and diligence.", author: "Abigail Adams" },
  { text: "Education is the passport to the future, for tomorrow belongs to those who prepare for it today.", author: "Malcolm X" },
  { text: "Intelligence plus character—that is the goal of true education.", author: "Martin Luther King Jr." },
  { text: "Change is the end result of all true learning.", author: "Leo Buscaglia" },
  { text: "The more I read, the more I acquire, the more certain I am that I know nothing.", author: "Voltaire" },
  { text: "Learning never exhausts the mind.", author: "Leonardo da Vinci" },
  { text: "Teachers can open the door, but you must enter it yourself.", author: "Chinese Proverb" },
  { text: "Tell me and I forget. Teach me and I remember. Involve me and I learn.", author: "Benjamin Franklin" },
  { text: "The whole purpose of education is to turn mirrors into windows.", author: "Sydney J. Harris" },
  { text: "The great aim of education is not knowledge but action.", author: "Herbert Spencer" },
  { text: "A person who never made a mistake never tried anything new.", author: "Albert Einstein" },
  { text: "Learning without thought is labor lost; thought without learning is perilous.", author: "Confucius" },
  { text: "Education is not preparation for life; education is life itself.", author: "John Dewey" },
  { text: "The mind is not a vessel to be filled, but a fire to be kindled.", author: "Plutarch" },
  { text: "The capacity to learn is a gift; the ability to learn is a skill; the willingness to learn is a choice.", author: "Brian Herbert" },
  { text: "Do not confine your children to your own learning, for they were born in another time.", author: "Chinese Proverb" },
  { text: "It is the mark of an educated mind to be able to entertain a thought without accepting it.", author: "Aristotle" },
  { text: "Learning is a treasure that will follow its owner everywhere.", author: "Chinese Proverb" },
  { text: "Education is not to reform students or amuse them or make them expert technicians. It is to unsettle their minds.", author: "Robert M. Hutchins" },
  { text: "A good education is a foundation for a better future.", author: "Elizabeth Warren" },
  { text: "The highest result of education is tolerance.", author: "Helen Keller" },
  { text: "Learning is a lifelong process of keeping abreast of change.", author: "Peter Drucker" },
  { text: "Study without desire spoils the memory, and it retains nothing that it takes in.", author: "Leonardo da Vinci" },
  { text: "Educating the mind without educating the heart is no education at all.", author: "Aristotle" },
  { text: "The aim of education should be to teach us rather how to think, than what to think.", author: "James Beattie" },
  { text: "Curiosity is the wick in the candle of learning.", author: "William Arthur Ward" },
  { text: "The only person who is educated is the one who has learned how to learn and change.", author: "Carl Rogers" },
  { text: "Don’t let what you cannot do interfere with what you can do.", author: "John Wooden" },
  { text: "A child without education is like a bird without wings.", author: "Tibetan Proverb" },
  { text: "He who opens a school door, closes a prison.", author: "Victor Hugo" },
  { text: "It is what we know already that often prevents us from learning.", author: "Claude Bernard" },
  { text: "The more you learn, the more you realize how much you don’t know.", author: "Aristotle" },
  { text: "Education is the kindling of a flame, not the filling of a vessel.", author: "Socrates" },
  { text: "The function of education is to teach one to think intensively and to think critically.", author: "Martin Luther King Jr." },
  { text: "Formal education will make you a living; self-education will make you a fortune.", author: "Jim Rohn" },
  { text: "To educate a person in mind and not in morals is to educate a menace to society.", author: "Theodore Roosevelt" },
  { text: "Wisdom begins with wonder.", author: "Socrates" },
  { text: "Self-education is, I firmly believe, the only kind of education there is.", author: "Isaac Asimov" },
  { text: "Learning is not compulsory... neither is survival.", author: "W. Edwards Deming" },
  { text: "A teacher affects eternity; he can never tell where his influence stops.", author: "Henry Adams" },
  { text: "Knowledge will bring you the opportunity to make a difference.", author: "Claire Fagin" },
  { text: "The educated differ from the uneducated as much as the living from the dead.", author: "Aristotle" }
];


const getMinuteAlignedIndex = () => Math.floor(Date.now() / 60000) % QUOTES.length;

const FooterBar = ({ qrSrc }) => {
  const initialTheme =
    document.documentElement.getAttribute("data-theme") ||
    localStorage.getItem("eaimTheme") ||
    "light";
  const [theme, setTheme] = useState(initialTheme);

  useEffect(() => {
    const onTheme = (e) => setTheme(e.detail);
    window.addEventListener("eaim-theme", onTheme);
    return () => window.removeEventListener("eaim-theme", onTheme);
  }, []);

  const colors = useMemo(() => {
    if (theme === "dark") {
      return {
        quoteBg: "#1F2733",
        quoteText: "#EDEFF5",
        quoteShadow: "0 2px 10px rgba(0,0,0,0.35)",
        infoTitle: "#C7D2E5",
        infoSub: "rgba(231, 237, 247, 0.75)",
        infoBadgeBg: "rgba(255,255,255,0.12)",
        infoBadgeFg: "#BBD2FF",
        qrPlaceholder: "rgba(255,255,255,0.12)",
      };
    }
    return {
      quoteBg: "#E9ECEF",
      quoteText: "#27323A",
      quoteShadow: "0 2px 6px rgba(0,0,0,0.1)",
      infoTitle: "#3A4A58",
      infoSub: "rgba(58,74,88,0.8)",
      infoBadgeBg: "#E8F3FF",
      infoBadgeFg: "#1677ff",
      qrPlaceholder: "rgba(0,0,0,0.15)",
    };
  }, [theme]);

  const [quoteIndex, setQuoteIndex] = useState(getMinuteAlignedIndex);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setQuoteIndex(getMinuteAlignedIndex());

    const msUntilNextMinute = 60000 - (Date.now() % 60000);
    timeoutRef.current = setTimeout(() => {
      setQuoteIndex(getMinuteAlignedIndex());
      intervalRef.current = setInterval(() => {
        setQuoteIndex(getMinuteAlignedIndex());
      }, 60000);
    }, msUntilNextMinute);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const currentQuote = useMemo(() => QUOTES[quoteIndex], [quoteIndex]);

  return (
    <footer
      style={{
        marginTop: "-20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        padding: "20px 30px",
        flexWrap: "wrap",
        rowGap: 12,
        background: "transparent",
        paddingBottom: "80px",
        paddingRight: "80px",
        paddingLeft: "80px"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
        <div
          style={{
            background: "#B31E8D",
            width: 80, height: 80, borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0, border: "10px solid #EF65CC",
          }}
        >
          <img src={BreadPNG} alt="Bread" width={70} height={70} />
        </div>

        <div
          style={{
            background: colors.quoteBg,
            padding: "10px 18px",
            borderRadius: 8,
            fontSize: 14,
            color: colors.quoteText,
            fontStyle: "italic",
            maxWidth: 600,
            boxShadow: colors.quoteShadow,
            lineHeight: 1.45,
          }}
        >
          “{currentQuote.text}” – <strong>{currentQuote.author}</strong>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, color: colors.infoTitle }}>
          <span
            aria-hidden
            style={{
              width: 22, height: 22, borderRadius: "50%",
              display: "grid", placeItems: "center",
              background: colors.infoBadgeBg, color: colors.infoBadgeFg,
              fontWeight: 700, fontSize: 14,
            }}
            title="Info"
          >
            i
          </span>
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontWeight: 700, color: colors.infoTitle }}>Scan QR code.</div>
            <div style={{ fontSize: 12, color: colors.infoSub, marginTop: 4 }}>You can find your classroom location</div>
          </div>
        </div>

        {qrSrc ? (
          <img
            src={qrSrc}
            alt="Scan to find classroom"
            style={{
              width: 80,
              height: 80,
              borderRadius: 8,
              boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
            }}
          />
        ) : (
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: 8,
              background: colors.qrPlaceholder,
            }}
          />
        )}
      </div>
    </footer>
  );
};

export default FooterBar;
